<template>
    <div
        class="VCombobox-wrapper"
        @keydown.tab.prevent
        @keyup="keyHandler"
    
    >
        <div
            class="VCombobox"
            :class="{'VCombobox_dropdown-active':isDropdownOpen}"
        >
        <span class="VCombobox__prefix">
            <slot name="prefix">
            
            </slot>
        </span>
            <span>
            <VInput
                :type="type"
                :placeholder="placeholder"
                v-model="localValue"
                @change="change"
                ref="vinput"
            ></VInput>
        </span>
            <span class="VCombobox__postfix">
            <slot name="postfix">
            
            </slot>
        </span>
            <div
                class="VCombobox-dropdown"
                v-if="isDropdownOpen"
            >
                <div
                    class="VCombobox-dropdown__item"
                    v-for="(item,itemIndex) in filteredItems"
                    :key="item"
                    :class="{'VCombobox-dropdown__item_active': activeItemIndex=== itemIndex }"
                    @click="chooseItem(item)"
                >{{ item }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'VCombobox',
        model: {
            prop: 'value',
            event: 'input',
        },
        props: {
            type: {
                type: String,
                default: 'text',
            },
            value: {
                type: String,
                required: true,
            },
            placeholder: {
                type: String,
                required: true,
            },
            searchItems: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                localValue: '',
                editWord: '',
                editWordIndex: '',
                activeItemIndex: -1,
            };
        },
        computed: {
            isDropdownOpen() {
                return this.filteredItems.length;
            },
            splittedText() {
                return this.localValue.split(/[.*+-/_]/);
            },
            filteredItems() {
                if (this.editWord.length > 0) {
                    return this.searchItems.filter((item) =>
                        item.toLowerCase().trim().includes(this.editWord.toLowerCase().trim()) && item.toLowerCase().trim() !== this.editWord.toLowerCase().trim());
                }
                return [];
            },
        },
        watch: {
            splittedText(newsplittedText, oldSplittedText) {
                this.editWordIndex = newsplittedText.findIndex(function (v, i) {
                    return v !== oldSplittedText[i];
                });
                this.editWord = newsplittedText[this.editWordIndex] || '';
            },
            value: {
                immediate: true,
                handler(newVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(this.localValue)) {
                        this.localValue = newVal;
                    }
                },
            },
            localValue: {
                handler(newVal) {
                    this.activeItemIndex = -1;
                    if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
                        this.$emit('input', newVal);
                    }
                },
            },
        },
        methods: {
            change() {
                this.$emit('change');
            },
            chooseItem(item) {
                const startSubstrPosition = this.splittedText.reduce((total, item, itemIndex) => {
                    return itemIndex < this.editWordIndex ? total + item.length + 1 : total;
                }, 0);
                let newLocalValue = this.localValue.split('');
                newLocalValue.splice(startSubstrPosition, this.editWord.length, item);
                newLocalValue = newLocalValue.join('');
                this.localValue = newLocalValue;
                this.$refs.vinput.$refs.input.focus();
            },
            keyHandler(event) {
                if (this.isDropdownOpen) {
                    switch (event.key) {
                        case 'ArrowUp':
                            this.activeItemIndex = this.activeItemIndex - 1 >= 0 ?
                                this.activeItemIndex - 1 : this.filteredItems.length - 1;
                            break;
                        case 'ArrowDown':
                            this.activeItemIndex = this.activeItemIndex + 1 < this.filteredItems.length ?
                                this.activeItemIndex + 1 : 0;
                            break;
                        case 'Tab':
                            this.activeItemIndex = this.activeItemIndex + 1 < this.filteredItems.length ?
                                this.activeItemIndex + 1 : 0;
                            break;
                        case 'Enter':
                            this.chooseItem(this.filteredItems[this.activeItemIndex]);
                            break;
                    }
                } else {
                    this.$emit(event.key.toLowerCase());
                }
            },
            inputEnter() {
                this.$emit('enter');
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VCombobox {
        width: 200px;
        position: absolute;
        
        &_dropdown-active {
            border-radius: 4px;
            border: 1px solid $primary-color;
            
            ::v-deep {
                .VInput input {
                    border: none;
                }
            }
        }
        
        &-wrapper {
            width: 201px;
            height: 30px;
        }
        
        &-dropdown {
            background: #fff;
            width: 100%;
            padding-bottom: 5px;
            border-radius: 5px;
            position: relative;
            z-index: $dropdown-z-index;
            
            &__item {
                cursor: pointer;
                padding: 4px 10px;
                
                &:hover {
                    background: $secondary-color;
                    color: #FFFFFF;
                }
                
                &_active {
                    background: $primary-color !important;
                    color: #FFFFFF;
                }
                
                
            }
        }
    }
</style>
